
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuotteet/naytatuoteliune/[slug]/[id]",
      function () {
        return require("private-next-pages/tuotteet/naytatuoteliune/[slug]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tuotteet/naytatuoteliune/[slug]/[id]"])
      });
    }
  